import React, { useEffect, useState, useCallback } from 'react';
import {
  Card,
  Tabs,
  Typography,
  Divider
} from 'antd';
import {
  CheckCircleOutlined,
  TagsOutlined,
  DollarOutlined
} from '@ant-design/icons';
import PlanManagement from './PlanManagement';
import FeatureManagement from './FeatureManagement';
import apiClient from 'services/apiClient';
import { useMyContext } from 'Context/MyContextProvider';
import { RoleData } from '../Role/Role';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const PricingManagement = () => {
  const { api, authToken } = useMyContext();
  // State management
  const [plans, setPlans] = useState([]);
  const [features, setFeatures] = useState([]);
  const [roles, setRoles] = useState([]);
  const [activeTab, setActiveTab] = useState('1');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    RoleData(api, authToken, setRoles, setLoading);
  }, [api, authToken]);

  const getFeature = useCallback(async () => {
    setLoading(true);
    try {
      // Use Promise.all to fetch both resources concurrently
      const [featureRes, planRes] = await Promise.all([
        apiClient.get(`${api}plan-features`, {
          headers: { 'Authorization': `Bearer ${authToken}` }
        }),
        apiClient.get(`${api}plans`, { // Corrected endpoint for plans
          headers: { 'Authorization': `Bearer ${authToken}` }
        })
      ]);

      // Set plans
      setPlans(planRes.data.success ? planRes.data.data : []);

      // Set features
      setFeatures(featureRes.data.success ? featureRes.data.data : []);

    } catch (error) {
      setFeatures([]);
      setPlans([]);
    } finally {
      setLoading(false);
    }
  }, [api, authToken]);

  useEffect(() => {
    getFeature();
  }, [getFeature]);


  return (
    <div className="pricing-management">
      <Card>
        <Title level={3}>
          <DollarOutlined /> Pricing Plan Management
        </Title>
        <Text type="secondary">
          Manage your pricing plans and features. Create, edit, or delete plans and control which features are included in each plan.
        </Text>

        <Divider />

        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane
            tab={<span><TagsOutlined /> Plans</span>}
            key="1"
          >
            <PlanManagement
              roles={roles}
              plans={plans}
              setPlans={setPlans}
              features={features}
              loading={loading}
              setFeatures={setFeatures}
            />
          </TabPane>

          <TabPane
            tab={<span><CheckCircleOutlined /> Features</span>}
            key="2"
          >
            <FeatureManagement
              features={features}
              setFeatures={setFeatures}
              loading={loading}
              plans={plans}
              setPlans={setPlans}
            />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default PricingManagement;